<template>
  <client-only>
    <section :class="['games-detail-page', gameName]">
      <CloudControl ref="cloudControl" />
      <FailurePage v-if="pageLoadFail" />
      <component v-bind:is="currentDisplayPlatform" v-if="!pageLoadFail">
        <component v-bind:is="currentDisplayMode" />
      </component>
      <CouponNotice :loginStatus="isLogin" />
      <CloudControlPopup />
      <MembersModalBox />
      <CrmElasticLayer :pageType="2" />
      <PopupList ref="popupList" :pageType="2" />
      <WarningPopup ref="warningPopup" />
      <!-- <GoodLayer /> -->
    </section>
  </client-only>
</template>
<script>
  import Vue from 'vue'
  import { Toast } from 'vant'
  import { recordPageViewCount } from './helper'
  import { queryOrderStatus } from '@/api/order'
  import { mapMutations, mapState, mapGetters } from 'vuex'
  import {
    OnlyDesktop,
    OnlyMobile,
    OnlyGameturbo,
    OnlyHorizontalScreen,
    DesktopDisplayMobile,
    is_display_gameTurbo,
    is_display_mobile,
    is_desktop_display_mobile,
  } from '@/components/DisplayType'
  import {
    GameDisplayGameturbo,
    GameDisplayMobile,
    GameDisplayNewDesktop,
  } from './clientType/home.js'
  import {
    getSkuListFromUidValidatorsGames,
    RENDER_TEMP,
    GAME_BY_WEAKNET_WORK,
    PARALLEL_REQUESTS_GAMES,
  } from './config'
  import {
    getSkuList,
    getSku2Channel,
    getServerList,
    getOuterChannelList,
    getCategorySku,
    getPayMethod,
    getCustomConfig,
    getExternalOuterSku,
  } from '@/api/games'

  import {
    mounted_track,
    shareSuccess,
    fission_share_success,
  } from '../firebase'
  import { pageClick } from './firebase'
  import { isJsonString } from '@/utils/tool'
  import { compressWebp } from '@/utils/webp'
  import { storage } from '@/utils/storage'
  import { handleDistributionData } from './utils/distributor'
  import { removeCookieState } from '@/utils/cookieUtils'
  import { setRelation } from '@/api/fission'
  import { tryToNative, changeTitleBarMode } from '@/utils/native'
  import MembersModalBox from '@/pages/Members/components/ModalBox'
  import CrmElasticLayer from '@/components/CrmElasticLayer'
  import membersMixins from '@/mixins/members'
  import CouponNotice from '@/components/CouponNotice'
  import CloudControl from './components/CloudControl'
  // import GoodLayer from './components/GoodLayer'
  import CloudControlPopup from '@/components/CloudControlPopup'
  import FailurePage from '@/components/FailurePage'
  import PopupList from '@/components/PopupList'
  import WarningPopup from '@/components/WarningPopup'
  import isEmpty from 'lodash/isEmpty'
  import cloneDeep from 'lodash/cloneDeep'
  import bus from '@/utils/bus'

  Vue.use(Toast)
  Toast.allowMultiple()
  Toast.setDefaultOptions({ className: 'server-toast' })

  export default {
    name: 'detail',
    mixins: [membersMixins],
    components: {
      OnlyDesktop,
      OnlyMobile,
      OnlyGameturbo,
      OnlyHorizontalScreen,
      GameDisplayNewDesktop,
      GameDisplayGameturbo,
      GameDisplayMobile,
      DesktopDisplayMobile,
      FailurePage,
      CloudControl,
      CloudControlPopup,
      CouponNotice,
      MembersModalBox,
      PopupList,
      WarningPopup,
      CrmElasticLayer,
      // GoodLayer,
    },
    head() {
      const gameName = this.getGameName() || ''
      return this.$getSeoHead(`detail_${gameName}`, this.region, gameName)
    },
    data() {
      return {
        customConfigData: {}, // CMS 默认配置
        serviceId: '',
        pageLoadFail: false, //页面加载失败
      }
    },
    async asyncData({ params, req }) {
      let cmsData = {}
      const { pathMatch, gameName } = params
      const country = pathMatch || 'id' // 默认印尼
      let options

      const ssrLocationParams = {
        host: req?.headers.host,
        url: req?.url,
        health_checks: req?.headers?.['is-health-examination'] || '',
      }

      try {
        options = {
          country,
          game: gameName || '',
        }
        const result = await getCustomConfig(
          options,
          {
            renderType: 'server',
            ssrdata: ssrLocationParams,
          },
          {
            'x-forwarded-for':
              req?.headers?.['x-client-for'] ||
              req?.headers?.['x-forwarded-for'] ||
              req?.headers?.['x-real-ip'] ||
              '',
            'x-client-for': req?.headers?.['x-client-for'] || '',
          }
        )

        cmsData = { detailConfig: result.detailConfig, gameName }
      } catch (error) {
        // eslint-disable-next-line
        console.warn('%c[_initCustomConfig_]方法报错', 'color:#0f0', error)
        // 服务端渲染失败、进行打点

        cmsData = {
          isGoback: true,
          error,
        }

        const time = new Date().toLocaleString()
        let url = ''
        let headers = ''
        let body = ''
        let ips = ''
        if (req) {
          url = req.url
          ips = req.ips
          body = JSON.stringify(req.body)
          headers = JSON.stringify(req.headers)
        }
        // eslint-disable-next-line
        console.log(
          'page detail api ===>>>',
          time,
          url,
          ips,
          body,
          headers,
          '\n',
          error
        )
      }

      return { customConfigData: cmsData }
    },
    computed: {
      ...mapState([
        'gameName',
        'isMobile',
        'isDesktop',
        'isTurbo',
        'isMiuiBrowser',
        'source',
        'region',
        'isApp',
        'isIAP',
      ]),
      ...mapState('detail', [
        'serverUserId',
        'selectServerItem',
        'detailBasicConfig',
        'selectSkuItem',
        'submitCloudControl',
        '_noReloadPage',
        'nickName',
        'selectChannelItem',
      ]),
      ...mapGetters([
        'isDistributor',
        'displayHorizontal',
        'isGameServers',
        'isLogin',
        'isGenshinEn',
        'isParallelRequestsGame',
        'isStateOfSurvival',
        'isMLBB',
        'isGetExternalServerCheckGamesAll',
        'selectedUidKey',
        'isGameOfKhans',
      ]),

      // 配置模板化的skuType
      skuConfigType() {
        return this.$__GAME__?.skuType || 1
      },
      currentMode() {
        const { isMobile, isTurbo, gameName } = this

        if (this.isDesktop) return 'display_new_desktop'
        if (is_display_gameTurbo(isMobile, isTurbo)) return 'display_gameTurbo'
        // 判断是否是横屏
        if (this.displayHorizontal) return 'display_horizontalScreen'
        if (is_display_mobile(isMobile, isTurbo)) {
          return 'display_mobile'
        }
        if (is_desktop_display_mobile(isMobile, gameName)) {
          return 'desktop_display_mobile'
        }
        return 'display_mobile'
      },
      currentDisplayPlatform() {
        const maps = {
          display_new_desktop: 'OnlyDesktop',
          display_gameTurbo: 'OnlyGameturbo',
          display_mobile: 'OnlyMobile',
          display_horizontalScreen: 'OnlyHorizontalScreen',
          desktop_display_mobile: 'DesktopDisplayMobile',
        }
        return maps[this.currentMode] || 'OnlyMobile'
      },
      currentDisplayMode() {
        const maps = {
          display_new_desktop: 'GameDisplayNewDesktop', // pc
          display_gameTurbo: 'GameDisplayGameturbo', //GT
          display_mobile: 'GameDisplayMobile', // H5
          desktop_display_mobile: 'GameDisplayMobile',
        }
        return maps[this.currentMode] || 'GameDisplayMobile'
      },

      // 有一种情况是、当前用户未登录使用钱包支付、调起登录需要监听登录状态 更新分销用户
      userSwitchPackages() {
        return {
          isLogin: this.isLogin,
          selectSku: this.selectSkuItem,
        }
      },
    },
    watch: {
      // pns、3d需要单独做部署
      nickName: {
        handler(newVal) {
          if (newVal && newVal.length && this.isParallelRequestsGame) {
            const roleId = newVal[0].roleId
            this.getExternalSku(roleId)
          }
        },
        deep: true,
      },
      isLogin: {
        handler(newVal) {
          newVal && this.contactFissionInfo()
        },
        immediate: true,
      },
      // 点击底部支付新组件、需要更新 this.noReloadPage 的值
      _noReloadPage(newVal) {
        if (newVal) {
          this.noReloadPage = newVal
        }
      },
      // 默认注入VUE全局原型链
      customConfigData: {
        handler(newVal) {
          const {
            gameName = '',
            detailConfig = '',
            isGoback = false,
            error = null,
          } = newVal

          if (isEmpty(newVal) || process.server) return

          if (isGoback || detailConfig.trim() === '') {
            window.console.warn(
              '%c[_initCustomConfig_]方法报错，\n 1、CMS的接口报错！请检查CMS配置后台是否启动 \n 2、接口数据返回是否正常？@学壮',
              'color:#0f0',
              {
                error,
                detailConfig,
                isGoback,
              }
            )
            this._tryToJump()
            return
          }
          const data = JSON.parse(detailConfig)

          // warn 默认只要H5站进行注入
          if (gameName && RENDER_TEMP.includes(gameName)) {
            Vue.prototype.$__GAME__ = data
          }
        },
        deep: true,
        immediate: true,
      },
      userSwitchPackages: {
        handler({ selectSku = {} }) {
          if (!isEmpty(selectSku)) {
            this.updatePaymentChannel(selectSku)
            // 考虑到配置SKU的时候 不同的SKU的前缀不一致的问题、动态矫正
            this.setCurrency(selectSku.currencySymbol)

            if (this.isGetExternalServerCheckGamesAll) {
              this.getServerDatas(selectSku.skuId)
            }
            this.getCloudControlState('clickSku', selectSku.skuId)
          } else {
            // 另外的一种情况是：斗罗、默认SKU是没有的
            this['detail/setPayChanState']('done')
          }
        },
        deep: true,
        immediate: true,
      },
      selectChannelItem: {
        handler(newVal) {
          if (!isEmpty(newVal)) {
            this.getCloudControlState('clickChannel', newVal.payMethod)
          }
        },
        deep: true,
        immediate: true,
      },
      submitCloudControl: {
        async handler(newVal) {
          if (!isEmpty(newVal)) {
            const { skuId, payMethod } = newVal
            const res = await this.getCloudControlState(
              'submit',
              skuId,
              payMethod,
              true
            )
            const status = res && res.length ? 'error' : 'success'
            this['detail/setSubmitClickStatus']({
              type: status,
              time: Date.now(),
            })
          }
        },
        deep: true,
      },
      selectServerItem: {
        handler(newVal) {
          if (!isEmpty(newVal)) {
            this.serviceId = newVal.cpServerId
            this['detail/setIsVpns'](-1)
          }
        },
        deep: true,
        immediate: true,
      },
      // pns\3d
      serverUserId: {
        handler(newVal) {
          if (!this.isParallelRequestsGame) return
          const { value = '' } = newVal

          if (value === '') {
            this.initParallelRequestsGame()
          } else {
            this.getServerDatas(value)
          }
        },
        deep: true,
      },

      detailBasicConfig(configs) {
        if (configs) {
          const { commonConfig } = configs || {}
          if (commonConfig && commonConfig.taxRate) {
            this.setMyTaxRate(Number(commonConfig.taxRate))
          }
        }
      },
    },
    created() {
      const gameName = this.getGameName()
      this.setGameName(gameName)
      if (!process.client) return

      this.getPayMethodList()
      this.initGenshinEnState()
      // 与显示方式相关的适配
      this.displayModeSettings()
      this.setInitSource()
      // 页面浏览次数
      recordPageViewCount(gameName, this.isMiuiBrowser, this.$route.query)
      this.initNewPackage()
      this.getQueryOrderStatus()
      const { source = 'xm-MVP', channelId } = this.$route.query
      if (source === 'share') {
        shareSuccess({ page: gameName, share_name: channelId })
        fission_share_success({
          page: 'home',
          share_name: channelId,
        })
      }
      // url中包含订单号时查询订单状态并进行付费打点
      if (this.isApp) {
        // app内详情页隐藏标题栏
        changeTitleBarMode(3)
        // 刷新页面
        window.addEventListener('pageVisible', this.onPageVisible)
      }
    },
    mounted() {
      mounted_track({ page: this.gameName }, 'copyright', null)
      bus.$on('show-account-risk', ({ errCode }) => {
        this.$refs.warningPopup.handler({ errCode })
      })
      pageClick()
    },
    beforeDestroy() {
      // 下单成功后，统一通过beforeDestroy关闭按钮的loading
      // 防止用户在下单成功后，跳转到下一个页面前的时间内再次点击下单按钮
      this.setCreateOrderState('success')

      bus.$off('show-account-risk')
      if (this.isApp) {
        // app内详情页展示标题栏
        changeTitleBarMode(0)
        window.removeEventListener('pageVisible', this.onPageVisible)
      }
    },
    methods: {
      ...mapMutations([
        'setGameName',
        'setSource',
        'setPwaStatus',
        'setIsTurbo',
        'setCurrency',
        'setSelectedSkuInfo',
        'setCreateOrderState',
        'setPaymentAccountInfo',
        'setMyTaxRate',
        'detail/setServerList',
        'detail/setPublicSkuList',
        'detail/setPayList',
        'detail/setIsVpns',
        'detail/setPaymentChannel',
        'detail/setSubmitClickStatus',
        'detail/setPayChanState',
        'detail/setNickName',
      ]),
      ...mapMutations('detail', ['setLoadingBySkuChannels']),

      // 关联裂变分享的用户记录
      async contactFissionInfo() {
        try {
          const { attachedKicoinId = '', activityId = '' } = this.$route.query

          if (attachedKicoinId !== '' && activityId !== '') {
            const pars = {
              activityId,
              country: this.region,
              fromKicoinId: attachedKicoinId,
            }
            await setRelation(pars)
          }
        } catch (error) {
          window.console.warn(
            '%c[__contactFissionInfo_]方法报错',
            'color:#0f0',
            error
          )
        }
      },
      // 获取地区所有支付方式
      async getPayMethodList() {
        try {
          const payList = await getPayMethod({
            country: this.region,
          })

          if (payList && Array.isArray(payList) && payList.length) {
            this['detail/setPayList'](payList)
          }
        } catch (error) {
          window.console.warn(
            '%c[getPayMethodList]方法报错',
            'color:#0f0',
            error
          )
        }
      },
      //  新增原神US的默认隐藏模块
      initGenshinEnState() {
        if (this.isGenshinEn) {
          const userToken = this.$cookies.get('systemToken') || null
          if (!userToken) return
          removeCookieState('systemToken')
        }
      },
      onPageVisible() {
        if (this.isIAP) {
          return
        }

        if (!this.noReloadPage) {
          window.location.reload()
        }
        this.noReloadPage = false
      },

      getQueryOrderStatus() {
        const { orderNo } = this.$route.query
        if (!orderNo) return

        queryOrderStatus(orderNo, this.region)
      },
      getGameName() {
        return (
          (this.$route.query.gameName &&
            this.$route.query.gameName.toLowerCase()) ||
          (this.$route.params.gameName &&
            this.$route.params.gameName.toLowerCase())
        )
      },
      setInitSource() {
        let source = this.$route.query?.source || ''

        if (source && Array.isArray(source) && source.length) {
          source = source[source.length - 1]
        }

        if (!source || source === 'undefined' || source === '') {
          source = 'ns'
        }
        if (this.isApp && source && source.toLocaleLowerCase() !== 'iap') {
          source = 'inapp'
        }
        this.setSource(source)
      },
      displayModeSettings() {
        this.setIsTurbo(!!(this.$route.query.mode === 'gt' && this.isMobile))
      },
      // todo 获取外部商品套餐的list
      async getExternalSku(roleId = '') {
        try {
          let parames = {
            game: this.gameName,
            country: this.region,
          }

          if (this.isParallelRequestsGame) {
            parames = {
              ...parames,
              uid: this.serverUserId.value,
              cpServerId: this.selectServerItem?.cpServerId || '',
              roleId,
            }
          }

          const res = await getExternalOuterSku(parames)

          if (this.isParallelRequestsGame) {
            if (res && res.length) {
              this['detail/setPublicSkuList'](res)
            } else {
              this._tryToJump()
            }
          } else {
            const [result] = res
            if (result.products == null || result.products.length == 0) {
              this._tryToJump()
            } else {
              const list = result.products
              this['detail/setPublicSkuList'](list)
            }
          }
        } catch (error) {
          this._tryToJump()
          window.console.warn(
            '%c[__getExternalOuterSku__]方法报错',
            'color:#0f0',
            error
          )
        }
      },

      _tryToJump() {
        tryToNative({
          url: 'home',
          params: null,
        }).catch(() => {
          this.$router_push({
            path: '/',
            query: {
              ...this.$route.query,
            },
          })
        })
      },
      // 针对pns\3d默认值处理
      initParallelRequestsGame() {
        if (this.isParallelRequestsGame) {
          this['detail/setServerList']([])
          this['detail/setPublicSkuList']([])
          this['detail/setPaymentChannel']([])
        }
      },

      async getSkulistDatas() {
        const notSkuGames = [
          ...getSkuListFromUidValidatorsGames,
          ...PARALLEL_REQUESTS_GAMES,
          'game-of-khans',
        ]

        if (notSkuGames.includes(this.gameName)) return

        try {
          let skuList = await getSkuList({
            game: this.gameName,
            status: 1,
            country: this.region,
          })

          if (!skuList || skuList.length === 0) {
            this._tryToJump()
            this.pageLoadFail = true
            return []
          }

          skuList = await this.compressSkuImg(skuList)
          // 秒杀Abtest
          this['detail/setPublicSkuList'](skuList)
          //warn  对于数据的修改、千万要返回数据的副本
          return cloneDeep(skuList)
        } catch (e) {
          this.pageLoadFail = true
        }
      },

      // 压缩当前的banner的图片不走懒加载
      async compressSkuImg(banners) {
        if (banners && banners.length) {
          return await Promise.all(
            banners.map(async (item) => {
              const picture = this.getSkuIcon(item)
              if (picture) {
                const surl = await compressWebp(picture.background_url)
                item.skuExtraInfo = JSON.stringify({ background_url: surl })
              }
              return item
            })
          )
        }
        return banners || []
      },

      getSkuIcon({ skuExtraInfo }) {
        if (skuExtraInfo && isJsonString(skuExtraInfo)) {
          return JSON.parse(skuExtraInfo) || {}
        }
        return null
      },

      async getCategorySku() {
        try {
          const result = await getCategorySku({
            game: this.gameName,
            status: 1,
            country: this.region,
          })

          this['detail/setPublicSkuList'](result)
        } catch (error) {
          this._tryToJump()
          window.console.warn('%c[getCategorySku]方法报错', 'color:#0f0', error)
        }
      },

      async initNewPackage() {
        if (this.isGameServers) {
          this.getServerDatas()
        }
        if (this.isGameOfKhans) {
          this.getCategorySku()
        } else if (this.skuConfigType && this.skuConfigType === 2) {
          // 初始化的时候\一些游默认不请求
          if (this.isParallelRequestsGame || this.isStateOfSurvival) return
          this.getExternalSku()
        } else {
          this.getSkulistDatas()
        }
      },

      async updatePaymentChannel(item) {
        const result = await this.getPaymentChannel(item)
        if (result === false) return
        this['detail/setPaymentChannel'](result)
      },

      // 通过skuPrice获取支付通道
      getOuterChannelListDatas(skuPrice) {
        if (!skuPrice) {
          return []
        }
        return getOuterChannelList({
          skuPrice,
          game: this.gameName,
          country: this.region,
        })
      },

      // 获取服务列表
      async getServerDatas(specifyId = '') {
        const parames = {
          game: this.gameName,
          country: this.region,
        }
        let options = {}
        if (this.isParallelRequestsGame) {
          options = {
            ...parames,
            uid: specifyId,
          }
        } else {
          options = {
            ...parames,
            skuId: specifyId,
          }
        }

        try {
          const serverList = await getServerList(options)
          this['detail/setServerList'](serverList)

          if (this.isParallelRequestsGame) {
            storage.set(this.selectedUidKey, specifyId)
          }
        } catch (error) {
          this['detail/setServerList']([])
          this.initParallelRequestsGame()
          window.console.warn(
            '%c[___getServerDatas__]方法报错',
            'color:#0f0',
            error
          )
        }
      },

      // 已经进行了CMS的sku配置
      async getPaymentChannel(item) {
        let result = []
        this['detail/setPayChanState']('pending')
        if (this.skuConfigType && this.skuConfigType === 1) {
          // 内部支付通道
          result = await this.getSkuOfChannelList(item.skuId)
          this['detail/setPayChanState']('done')
        } else if (this.skuConfigType && this.skuConfigType === 2) {
          result = await this.getOuterChannelListDatas(item.skuPrice)
          this['detail/setPayChanState']('done')
        } else {
          this['detail/setPayChanState']('done')
        }

        return cloneDeep(result)
      },
      // 获取当前套餐对应的支付通道所有信息
      async getSkuOfChannelList(skuId) {
        let currentChannelList = []

        // 弱网兼容
        if (GAME_BY_WEAKNET_WORK.indexOf(this.gameName) > -1) {
          this.setLoadingBySkuChannels({ key: skuId, value: true })
          const data = (await this.getSku2ChannelList(skuId)) || []
          this.setLoadingBySkuChannels({ key: skuId, value: false })
          currentChannelList = data
          const currentSkuId = this.selectSkuItem?.skuId || ''
          if (skuId !== currentSkuId) return false
        } else {
          const data = (await this.getSku2ChannelList(skuId)) || []
          currentChannelList = data
        }

        return currentChannelList
      },
      // 获取当前套餐对应的支付通道
      async getSku2ChannelList(skuId) {
        if (this.isIAP) return
        if (!skuId) return
        try {
          const pars = {
            skuId,
            game: this.gameName,
            status: 1,
            country: this.region,
            isRoute: true,
          }

          const data = await getSku2Channel(pars)
          return this.handleDistributor(data)
        } catch (e) {
          this.pageLoadFail = true
        }
      },
      async getCloudControlState(type, id1, id2, showLoading) {
        if (!this.$refs.cloudControl) return
        try {
          return await this.$refs.cloudControl.getConfigInfo(
            type,
            id1,
            id2,
            showLoading
          )
        } catch (e) {
          window.console.log(e)
        }
      },
      // 处理分销账户
      handleDistributor(data = []) {
        if (!this.isDistributor) return data
        return handleDistributionData(data)
      },
    },
  }
</script>
